import { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { FixingContext, useValidateFixing } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectFixingMarginType, selectFixingPriceType } from '@/store/orders/fixing/selectors.ts';

export const FixingMarginType = () => {
  const tileId = useContext(FixingContext).tileId;
  const fixingMarginType = useAppSelector((state) => selectFixingMarginType(state, tileId));
  const fixingPriceType = useAppSelector((state) => selectFixingPriceType(state, tileId));
  const track = useTrackEvent();

  const validateFixing = useValidateFixing();

  const handleMarginTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Margin type changed');
    const newMarginType = event.target.value as 'MarginInBps' | 'BidAskMidSpread';

    validateFixing({
      fixingMarginType: newMarginType,
    });
  };

  return (
    <OrderRow labelId="order.fields.marginType">
      <Form.Select value={fixingMarginType} onChange={handleMarginTypeChange} size="sm" data-e2e="margin-type-selector">
        <option key="MarginInBps" value="MarginInBps">
          <FormattedMessage id="order.form.marginType.MarginInBps" />
        </option>
        {fixingPriceType !== 'BIDASK' && (
          <option key="BidAskMidSpread" value="BidAskMidSpread">
            <FormattedMessage id="order.form.marginType.BidAskMidSpread" />
          </option>
        )}
      </Form.Select>
    </OrderRow>
  );
};
